<template>
  <span class="status-badge" :class="statusClass">
    {{ statusLabel }}
  </span>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'SaleStatusBadge',
  props: {
    sale: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    // Vérifier si la vente est impayée (pas de payments)
    const isUnpaid = computed(() => {
      return !props.sale.payments || props.sale.payments.length === 0;
    });

    // Vérifier si la vente a une facture associée
    const hasInvoice = computed(() => {
      return props.sale.sale_invoice_id !== null && props.sale.sale_invoice_id !== undefined;
    });

    const statusLabel = computed(() => {
      const status = props.sale.status;

      // Si la vente a une facture, afficher "Facturée"
      if (hasInvoice.value) {
        return 'Facturée';
      }

      // Labels standards basés sur le status
      const labels = {
        'pending': 'En attente',
        'completed': 'Complétée',
        'paid': 'Payée',
        'partial_paid': 'Paiement partiel',
        'refunded': 'Remboursée',
        'partial_refund': 'Remb. partiel'
      };

      return labels[status] || status;
    });

    const statusClass = computed(() => {
      const status = props.sale.status;

      // Si la vente a une facture, style facturée
      if (hasInvoice.value) {
        return 'status-invoiced';
      }

      // Classes standards basées sur le status
      const classes = {
        'pending': 'status-pending',
        'completed': 'status-completed',
        'paid': 'status-paid',
        'partial_paid': 'status-partial-paid',
        'refunded': 'status-refunded',
        'partial_refund': 'status-partial'
      };

      return classes[status] || '';
    });

    return {
      statusLabel,
      statusClass,
      isUnpaid,
      hasInvoice
    };
  }
});
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* En attente - Orange */
.status-pending {
  background-color: #fff3e0;
  color: #e65100;
}

/* Complétée - Bleu */
.status-completed {
  background-color: #e3f2fd;
  color: #1565c0;
}

/* Payée - Vert */
.status-paid {
  background-color: #e8f5e9;
  color: #2e7d32;
}

/* Paiement partiel - Bleu */
.status-partial-paid {
  background-color: #e3f2fd;
  color: #1565c0;
}

/* Remboursée - Rouge */
.status-refunded {
  background-color: #ffebee;
  color: #c62828;
}

/* Remboursement partiel - Rouge clair */
.status-partial {
  background-color: #fce4ec;
  color: #ad1457;
}

/* Facturée - Violet/Indigo */
.status-invoiced {
  background-color: #ede7f6;
  color: #5e35b1;
}
</style>
